/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Spinner from '@atlaskit/spinner';
import { ICON_SIZE_THRESOLD } from './constants';
import { Frame } from './frame';
export var InlineImageCardLoadingView = function InlineImageCardLoadingView(_ref) {
  var _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'media-inline-image-card-loading-view' : _ref$testId,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? ICON_SIZE_THRESOLD : _ref$height;
  return jsx(Frame, {
    testId: testId
  }, jsx(Spinner, {
    size: height > ICON_SIZE_THRESOLD ? 'medium' : 'small',
    interactionName: "media-inline-spinner"
  }));
};